import { t } from "@/lib/strings";

export const Footer = () => (
  <footer className="bg-obsidian text-white border-t-2 border-neutral-800">
    <div className="av-container py-10 flex flex-col md:flex-row items-center justify-between gap-4">
      <div className="flex items-center gap-2">
        <img src="/dev4u-mark.svg" alt="dev4u" className="h-8 w-8" />
        <span className="font-heading font-bold text-lg" dir="ltr">dev<span className="text-conversion">4</span>u</span>
      </div>
      <p className="font-data text-xs text-neutral-500 text-center">
        © <span dir="ltr">{new Date().getFullYear()}</span> {t("footer.line")}
      </p>
      <a href="/admin" className="font-data text-xs uppercase tracking-widest text-neutral-500 hover:text-conversion transition-colors" data-testid="admin-link">
        Admin
      </a>
    </div>
  </footer>
);

export default Footer;
